import { useTranslation } from "react-i18next";
import { Modal, StatusIndicator } from "@unified-checkout/design-system";
import { ArrowsRepeat, Check, Clock, Xmark } from "@unified-checkout/design-system/icons/index";
import type { IButton } from "libs/design-system/src/types/Button/button";
import type { IModalSharedProps } from "libs/design-system/src/types/modal";
import type { IConnect } from "@app/dashboard/types/innerLayout/xero/connect";
import styles from "./connect.module.scss";

export const ConnectModal = ({
    isModalOpen,
    setIsModalOpen,
    isRequestFailed,
    modalState,
    onTryAgain,
    onCancel,
    isLoading
}: IConnect) => {
    const { t } = useTranslation();

    const isRedirecting = modalState === "redirecting";
    const isConfiguring = modalState === "configuring";
    const isSuccess = modalState === "success";
    const isFailed = modalState === "failed";
    const isErrorState = isFailed || isRequestFailed;

    const title = isSuccess ? t('innerLayout.xeroPage.modals.connectSuccessTitle')
        : isErrorState ? t('innerLayout.xeroPage.modals.connectErrorTitle')
            : isConfiguring ? t('innerLayout.xeroPage.modals.connectConfigTitle')
                : t('innerLayout.xeroPage.modals.connectRedirectTitle');

    const description = isSuccess ? t('innerLayout.xeroPage.modals.connectSuccessDesc')
        : isErrorState ? t('innerLayout.xeroPage.modals.connectErrorDesc')
            : isConfiguring ? t('innerLayout.xeroPage.modals.connectConfigDesc')
                : t('innerLayout.xeroPage.modals.connectRedirectDesc');

    const btns = isErrorState ? [
        {
            text: t('innerLayout.xeroPage.modals.connectTryAgain'),
            size: 'md',
            variant: 'contained',
            color: 'primary',
            onClickHandler: () => onTryAgain?.(),
            loading: isLoading
        } as IButton,
        {
            text: t('innerLayout.xeroPage.modals.connectCancel'),
            size: 'md',
            variant: 'outlined',
            color: 'secondary',
            onClickHandler: () => handleCancel()
        } as IButton
    ]
        : undefined;

    const handleCancel = () => {
        if (onCancel) {
            onCancel();
            return;
        }

        setIsModalOpen(false);
    };

    const icons = isSuccess ? Check
        : isErrorState ? Xmark
            : isConfiguring ? Clock
                : ArrowsRepeat

    const status = isSuccess ? "success"
        : isErrorState ? "error"
            : "default"

    const modalProps: IModalSharedProps = {
        state: isSuccess ? 'success' : isErrorState ? 'danger' : 'default',
        open: isModalOpen,
        position: "center",
        hasCloseIcon: true,
        onCloseHandler: handleCancel,
        btnsProps: btns,
        wrapperClassName: styles["connect-modal"]
    };

    return (
        <Modal {...modalProps}>
            <div className={styles["connect-modal__content"]}>
                <StatusIndicator
                    status={status}
                    icon={icons}
                    text={title}
                    hintText={description}
                />
            </div>
        </Modal>
    );
};
